function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("tspan", {
  x: "3.654px 7.591px 11.592px 15.995px 20.199px 24.602px 27.404px 30.141px 32.944px 37.347px 41.749px 45.953px 49.89px 53.827px 58.43px 62.833px 65.635px 68.372px 71.175px 76.242px 80.446px 84.849px 89.252px 92.054px 96.658px ",
  y: "20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px 20.384px "
}, "ATHER | CREATOR | WARRIOR");

var SvgSlice7 = function SvgSlice7(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 100 22",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
    className: "color",
    d: "M55.106,16.68l-54.971,0l0,-16.627l54.971,0l0,16.627Zm-54.171,-15.827l0,15.027l53.371,0l0,-15.027l-53.371,0Z",
    style: {
      fill: "#383838"
    }
  }), React.createElement("text", {
    className: "color",
    x: "3.889px",
    y: "12.128px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: "9.663px",
      fill: "#383838"
    }
  }, "ANTHONY")), React.createElement("g", null, React.createElement("path", {
    className: "color",
    d: "M99.214,0.053l0,16.627l-44.415,0l0,-16.627l44.415,0Zm-35.634,8.489c0,-1.148 0.308,-2.047 0.925,-2.697c0.616,-0.649 1.412,-0.974 2.387,-0.974c0.639,0 1.215,0.152 1.727,0.458c0.513,0.305 0.904,0.73 1.173,1.276c0.269,0.546 0.403,1.165 0.403,1.857c0,0.701 -0.141,1.329 -0.424,1.882c-0.283,0.554 -0.685,0.973 -1.204,1.258c-0.519,0.284 -1.078,0.427 -1.679,0.427c-0.651,0 -1.233,-0.158 -1.746,-0.472c-0.513,-0.315 -0.901,-0.744 -1.166,-1.288c-0.264,-0.544 -0.396,-1.12 -0.396,-1.727Zm24.239,2.552l0,-6.1l-0.916,0l0,6.917l4.322,0l0,-0.817l-3.406,0Zm5.374,0l0,-6.1l-0.916,0l0,6.917l4.322,0l0,-0.817l-3.406,0Zm-7.677,-5.284l0,-0.816l-5.002,0l0,6.917l5.162,0l0,-0.817l-4.246,0l0,-2.354l3.826,0l0,-0.812l-3.826,0l0,-2.118l4.086,0Zm-25.413,3.289c0.978,0 1.654,-0.204 2.029,-0.611c0.374,-0.408 0.561,-0.906 0.561,-1.494c0,-0.343 -0.07,-0.657 -0.21,-0.944c-0.14,-0.286 -0.325,-0.508 -0.554,-0.667c-0.23,-0.159 -0.515,-0.267 -0.854,-0.323c-0.243,-0.044 -0.593,-0.066 -1.053,-0.066l-2.609,0l0,6.917l0.916,0l0,-2.812l1.774,0Zm17.642,2.812l1.897,-6.917l-0.921,0l-1.085,4.444c-0.141,0.567 -0.256,1.068 -0.344,1.505c-0.11,-0.764 -0.29,-1.58 -0.538,-2.448l-0.991,-3.501l-1.104,0l-1.317,4.671c-0.031,0.113 -0.135,0.539 -0.311,1.278c-0.082,-0.468 -0.179,-0.94 -0.292,-1.415l-1.053,-4.534l-0.939,0l1.836,6.917l0.934,0l1.467,-5.271c0.063,-0.223 0.131,-0.494 0.203,-0.811c0.022,0.1 0.095,0.371 0.217,0.811l1.458,5.271l0.883,0Zm-13.221,-3.355c0,0.834 0.224,1.49 0.672,1.97c0.448,0.48 1.011,0.719 1.687,0.719c0.689,0 1.256,-0.242 1.701,-0.726c0.445,-0.485 0.668,-1.172 0.668,-2.062c0,-0.563 -0.096,-1.055 -0.286,-1.475c-0.19,-0.42 -0.469,-0.745 -0.835,-0.976c-0.366,-0.232 -0.778,-0.347 -1.234,-0.347c-0.648,0 -1.205,0.222 -1.673,0.668c-0.467,0.445 -0.7,1.188 -0.7,2.229Zm-4.426,-2.746c0.415,0 0.7,0.02 0.854,0.061c0.239,0.066 0.432,0.202 0.578,0.408c0.146,0.206 0.219,0.454 0.219,0.743c0,0.4 -0.124,0.71 -0.372,0.93c-0.249,0.22 -0.669,0.33 -1.26,0.33l-1.788,0l0,-2.472l1.769,0Z",
    style: {
      fill: "#383838"
    }
  }))), React.createElement("text", {
    className: "color",
    x: "-0.149px",
    y: "20.384px",
    style: {
      fontFamily: "'ArialMT', 'Arial', sans-serif",
      fontSize: "3.594px",
      fill: "#383838"
    }
  }, "F", _ref2)));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSlice7, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/slice7.d1856005.svg";
export { ForwardRef as ReactComponent };